/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreClientRequest
 */
export interface StoreClientRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreClientRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreClientRequest
     */
    sso_domain?: string | null;
}

/**
 * Check if a given object implements the StoreClientRequest interface.
 */
export function instanceOfStoreClientRequest(value: object): value is StoreClientRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function StoreClientRequestFromJSON(json: any): StoreClientRequest {
    return StoreClientRequestFromJSONTyped(json, false);
}

export function StoreClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'sso_domain': json['sso_domain'] == null ? undefined : json['sso_domain'],
    };
}

export function StoreClientRequestToJSON(json: any): StoreClientRequest {
    return StoreClientRequestToJSONTyped(json, false);
}

export function StoreClientRequestToJSONTyped(value?: StoreClientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'sso_domain': value['sso_domain'],
    };
}

